export const allGames = [
  {
    name: 'Super Ace',
    provider: 'JILI',
    category: 'Slots',
    isNew: false,
    isPopular: true,
    image: '/game-images/super-ace-deluxe.png'
  },
  {
    name: 'Aztec Bonus Hunt 2',
    provider: 'AdvantPlay',
    category: 'Slots',
    isNew: false,
    isPopular: true,
    image: '/game-images/aztec-bonus-hunt-2.png'
  },
  {
    name: 'Rockin Joker',
    provider: 'BNG',
    category: 'Slots',
    isNew: false,
    isPopular: true,
    image: '/game-images/rockin-joker.png'
  },
  {
    name: 'Blackjack Lucky Ladies',
    provider: 'JILI',
    category: 'Blackjack',
    isNew: true,
    isPopular: true,
    image: '/game-images/jili-blackjack-lucky-ladies.png'
  },
  {
    name: 'Ace333 Roulette',
    provider: 'ACE333',
    category: 'Roulette',
    isNew: true,
    isPopular: true,
    image: '/game-images/ace333-roulette.png'
  },
  {
    name: 'Ace333 Baccarat',
    provider: 'ACE333',
    category: 'Baccarat',
    isNew: false,
    isPopular: true,
    image: '/game-images/ace333-baccarat.png'
  },
  {
    name: 'Rave Jump',
    provider: 'CQ9',
    category: 'Slots',
    isNew: true,
    isPopular: true,
    image: '/game-images/rave-jump.png'
  },
  {
    name: 'Gates of Olympus',
    provider: 'Pragmatic Play',
    category: 'Slots',
    isNew: false,
    isPopular: true,
    image: '/game-images/gates-of-olympus-1000.png'
  },
  {
    name: 'Roulette12',
    provider: 'MG888H5',
    category: 'Roulette',
    isNew: true,
    isPopular: true,
    image: '/game-images/mg888h5-roulette12.png'
  },
  {
    name: 'Rich88 Baccarat',
    provider: 'Rich88',
    category: 'Baccarat',
    isNew: false,
    isPopular: false,
    image: '/game-images/rich88-baccarat.png'
  },
  {
    name: 'Aztac',
    provider: 'Xe88',
    category: 'Slots',
    isNew: false,
    isPopular: true,
    image: '/game-images/aztac.png'
  },
  {
    name: 'Single Blackjack',
    provider: 'Rich88',
    category: 'Blackjack',
    isNew: true,
    isPopular: true,
    image: '/game-images/rich88-single-blackjack.png'
  },
  {
    name: 'Virtual Tiger Baccarat',
    provider: 'Pegasus',
    category: 'Baccarat',
    isNew: false,
    isPopular: false,
    image: '/game-images/pegasus-virtual-tiger-baccarat.png'
  },
  {
    name: 'Cyber Rabbit Jackpot',
    provider: 'VPlus',
    category: 'Slots',
    isNew: true,
    isPopular: true,
    image: '/game-images/cyber-rabbit-jackpot.png'
  },
  {
    name: 'Caishen Baoxi',
    provider: 'Pegasus',
    category: 'Slots',
    isNew: false,
    isPopular: true,
    image: '/game-images/caishen-baoxi.png'
  },
  {
    name: 'Lanterns of Luck',
    provider: 'WF Gaming',
    category: 'Slots',
    isNew: true,
    isPopular: true,
    image: '/game-images/lanterns-of-luck.png'
  },
  {
    name: 'Xe88 Baccarat',
    provider: 'Xe88',
    category: 'Baccarat',
    isNew: true,
    isPopular: true,
    image: '/game-images/xe88-baccarat.png'
  },
  {
    name: 'Roulette24',
    provider: 'Xe88',
    category: 'Roulette',
    isNew: true,
    isPopular: true,
    image: '/game-images/xe88-roulette24.png'
  },
  {
    name: 'Circus Joker 4096',
    provider: 'JILI',
    category: 'Slots',
    isNew: true,
    isPopular: true,
    image: '/game-images/circus-joker-4096.png'
  },
  {
    name: 'Maya Lock',
    provider: 'BNG',
    category: 'Slots',
    isNew: true,
    isPopular: true,
    image: '/game-images/mayalock-break-and-win.png'
  },
  {
    name: 'Sexy Baccarat',
    provider: 'Me99',
    category: 'Live Casino',
    isNew: true,
    isPopular: true,
    image: '/game-images/me99-sexy-baccarat.png'
  },
  {
    name: 'Yeebet',
    provider: 'BigPay77',
    category: 'Live Casino',
    isNew: true,
    isPopular: true,
    image: '/game-images/bigpay77-yeebet.png'
  },
  {
    name: 'Big Gaming',
    provider: 'iPay9',
    category: 'Live Casino',
    isNew: true,
    isPopular: true,
    image: '/game-images/ipay9-big-gaming.png'
  },
  {
    name: 'CT855 Live Casino',
    provider: 'Spinaroo',
    category: 'Live Casino',
    isNew: true,
    isPopular: true,
    image: '/game-images/spinaroo-ct855-live-casino.png'
  },
  {
    name: 'W Casino',
    provider: 'MrBean9',
    category: 'Live Casino',
    isNew: true,
    isPopular: true,
    image: '/game-images/mrbean9-w-casino.png'
  },
  {
    name: 'Pragmatic Play',
    provider: 'Kingbet9',
    category: 'Live Casino',
    isNew: true,
    isPopular: true,
    image: '/game-images/kingbet9-pragmatic-play.png'
  }
];